import { css } from 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import _Image from 'reakit/Image';

var fitProperties = function fitProperties(props) {
  if (!props.fit) return;

  if (props.fit === 'contain') {
    return css(["object-fit:contain;", ";", ";", ";"], function (props) {
      return props.fitPosition ? css(["object-position:", ";"], props.fitPosition) : '';
    }, theme('fannypack.Image.fit.base'), theme('fannypack.Image.fit.contain'));
  }

  if (props.fit === 'cover') {
    return css(["object-fit:cover;", ";", ";", ";"], function (props) {
      return props.fitPosition ? css(["object-position:", ";"], props.fitPosition) : '';
    }, theme('fannypack.Image.fit.base'), theme('fannypack.Image.fit.cover'));
  }

  return null;
};

var fixedProperties = function fixedProperties(props) {
  if (!props.isFixed) return;
  return css(["max-width:unset;", ";"], theme('fannypack.Image.fixed'));
};

var Image = styled(_Image).withConfig({
  displayName: "styled__Image",
  componentId: "sc-19nzt74-0"
})(["max-width:100%;&{", ";}&{", ";}", ";"], fitProperties, fixedProperties, theme('fannypack.Image.base'));
export default Image;
export { Image, fitProperties, fixedProperties };